import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressMark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_2680_9990)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M1.5 7.5C1.5 4.18629 4.18629 1.5 7.5 1.5C10.8137 1.5 13.5 4.18629 13.5 7.5C13.5 10.8137 10.8137 13.5 7.5 13.5C4.18629 13.5 1.5 10.8137 1.5 7.5Z",
				fill: "#38539A"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M7.5 2C10.5376 2 13 4.46243 13 7.5C13 10.5376 10.5376 13 7.5 13C4.46243 13 2 10.5376 2 7.5C2 4.46243 4.46243 2 7.5 2Z",
				stroke: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_2680_9990",
			x: 0,
			y: 0,
			width: 15,
			height: 15,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .75 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_2680_9990"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_2680_9990",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgProgressMark);
export { ForwardRef as ReactComponent };
